import { getConfigTextMock } from './mock';

export default {
  getConfigText: () => getConfigTextMock()
};
